import { render, staticRenderFns } from "./CandyBar.vue?vue&type=template&id=a4b21ce2&scoped=true&"
import script from "./CandyBar.vue?vue&type=script&lang=js&"
export * from "./CandyBar.vue?vue&type=script&lang=js&"
import style0 from "./CandyBar.vue?vue&type=style&index=0&id=a4b21ce2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b21ce2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/builder/shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4b21ce2')) {
      api.createRecord('a4b21ce2', component.options)
    } else {
      api.reload('a4b21ce2', component.options)
    }
    module.hot.accept("./CandyBar.vue?vue&type=template&id=a4b21ce2&scoped=true&", function () {
      api.rerender('a4b21ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CandyBar/CandyBar.vue"
export default component.exports